export default "assets/images/Vector-7cc97e1e.svg";